<template>
  <AuthLayout>
    <Recovery />
  </AuthLayout>
</template>

<script>
  import Recovery from '@/containers/auth/Recovery';
  import AuthLayout from '@/layouts/Auth';

  export default {
    meta: {
      title: 'Password recovery',
    },
    components: { AuthLayout, Recovery },
  };
</script>
